import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { paths } from '@constants/paths';
import { useLoader } from '@hooks/useLoader';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { RequestState } from '@src/types/index';

const BasketGuard = () => {
  const { basketGuardData, basketGuardLoading } = useBasketContext();
  const { setRequestState } = useLoader();
  useEffect(() => {
    setRequestState(
      basketGuardLoading ? RequestState.loading : RequestState.success
    );
  }, [basketGuardLoading, setRequestState]);

  if (basketGuardLoading) {
    return null;
  }

  const id = basketGuardData?.basket?.id;

  if (!id && !basketGuardLoading) {
    return <Navigate to={paths.root} replace />;
  }

  return <Outlet />;
};

export { BasketGuard };
